import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input } from 'react-materialize';
import moment from 'moment';
import * as actions from '../../actions';

class DatePresetSelect extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const datePreset = event.target.value;
    const { setDate } = this.props;
    this.props.selectDatePreset(datePreset);

    // Add helper function to take in the values of selected preset
    // Convert them to momentjs for startDate and endDate
    // Update graph + data when selected

    const getStartDate = datePreset => {
      switch(datePreset) {
        case 'yesterday':
          return moment().subtract(1 + 1, 'day');
        case 'three_days':
          return moment().subtract(3 + 1, 'days');
        case 'seven_days':
          return moment().subtract(7 + 1, 'days');
        case 'two_weeks':
          return moment().subtract(14 + 1, 'days');
        case 'last_month':
          return moment().subtract(30 + 1, 'days');
        case 'three_months':
          return moment().subtract(90 + 1, 'days');
        case 'six_months':
          return moment().subtract(180 + 1, 'days')
        case 'one_year':
          return moment().subtract(1, 'year')
        case 'all_time':
          return moment().subtract(16, 'months')
        default:
          return false;
      }
    };

    const startDate = getStartDate(datePreset);
    const endDate = moment().subtract(2, 'days');

    setDate(startDate, endDate);
  }

  render() {
    return (
      <Input
        type="select"
        label="Date Preset"
        onChange={this.handleChange}
        defaultValue="two_weeks"
        className="date-preset-input"
        checked={false}
        s={12} m={3} l={3}
      >
        <option value="yesterday">Yesterday</option>
        <option value="three_days">Last 3 Days</option>
        <option value="seven_days">Last 7 Days</option>
        <option value="two_weeks">Last 2 Weeks</option>
        <option value="last_month">Last Month</option>
        <option value="three_months">Last 3 Months</option>
        <option value="six_months">Last 6 Months</option>
        <option value="one_year">Last Year</option>
        <option value="all_time">All Time</option>
        <option value="custom">Custom</option>
      </Input>
    );
  }
}

function mapStateToProps({ datePreset, startDate }) {
  return { datePreset, startDate };
}

export default connect(mapStateToProps, actions)(DatePresetSelect);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DatePresetSelect.js